<template>
  <div class="clearfix px2">
    <haandvaerker></haandvaerker>
    <b-alert v-if="show" show variant="warning" >Loading....</b-alert>
    <div v-if="project_id !== undefined">
      <p class="h5 pt3 darkblue semi-bold gibson line-height-golden">Opdater projekt:<br>
        <span class="h3 regular">{{ title }}</span>
      </p>
    </div>
    <div v-if="success">
      <p class="h4 gibson semi-bold darkblue line-height-3">
        Gennemført!
      </p>
      <p class="h5 darkblue regular gibson line-height-golden" v-if="project_id === undefined">
        Dit projekt er tilføjet.
      </p>
      <p class="h5 darkblue regular gibson line-height-golden" v-if="project_id !== undefined">
        Dit projekt er opdateret.
      </p>
      <div class="py2 flex flex-column">
        <span class="h6 regular gibson mediumgrey block m0">Projekt Url: </span>
        <p class="h4 semi-bold darkblue line-height-golden mb0">{{url}}</p>
      </div>
      <div>
        <button href="javascript:void(0)" class="col-12 facebook-button p1 py2 mt3 pointer no-hover flex justify-start items-center" @click="facebokUrl(url)">
          <span class="mr1 relative" style="top:-4px;">
            <img src="/static/svg/facebook.svg" alt="" width="20" height="20">
          </span>
          <span class="h6 semi-bold mb0 white left-align pl1">Del dit projekt på Facebook</span>
        </button>
        <button v-clipboard:copy="url" v-clipboard:success="successCopy" v-clipboard:error="onErrorCopy" class="col-12 action-button p2 h5 my2 flex justify-center itemws-center gibson">
          <span class="regular">Kopiér url</span>
          <span class="ml1"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </div>
    <div v-if="showMobile">
      <form-wizard ref="wizard" title="" v-if="!success" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949">
        <tab-content title="1" :before-change="validateFirstStep" v-if="project_id === undefined">
          <div class="gibson">
            <p class="h4 darkblue line-height-golden">Billeder</p>
            <p :show="noImage" class="h5 darkblue regular gibson mb2 line-height-3">
              Start med at uploade billeder
            </p>
            <p class="h6 darkblue gibson" :v-html="images.length + ' Billede'"></p>
            <div class="clearfix flex flex-wrap mb2">
              <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
              <div v-for="image in images" :key="image">
                <div class="px2 flex flex-column justify-center items-center mb2">
                  <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                  <button @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="1" v-if="project_id !== undefined">
          <div class="gibson">
            <p class="h4 darkblue line-height-golden">Billeder</p>
            <p class="h6 darkblue gibson" :v-html="images.length + ' Billede'"></p>
            <projectimages :project="project" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image_other" @rorate_image="rorate_image"></projectimages>
          </div>
        </tab-content>
        <tab-content title="2" :before-change="validateSecondStep">
          <div class="clearfix gibson">
            <p class="h4 darkblue line-height-golden gibson mb3">Projektinformationer</p>
          </div>
          <div class="clearfix">
            <p class="darkblue gibson line-height-1 mb1">
              <span>Opgavetype:</span><span class="red">*</span>
            </p>
            <v-select multiple placeholder="Begynd at skrive for at søge" label="TaskTypeName" v-model="tasktype" :state="validationType" :options="taskoptions" required class="gibson h5 flex flex-wrap col-12 self-stretch px0">
              <template slot="no-options">
                <p class="h5 darkblue gibson">Ingen matchende ...</p>
              </template>
            </v-select>
            <b-alert :show="validationType === false" variant="danger">Required</b-alert>
          </div>
          <div class="clearfix my3">
            <p class="darkblue gibson line-height-1 mb1">
              <span>Titel</span><span class="red">*</span>
            </p>
            <input class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none" v-model="title" :state="validationTitle" type="text" required>
            <b-alert :show="validationType === false" class="p1 gibson h5 semi-bold flex justify-start items-center red">
              <span>Required</span>
            </b-alert>
          </div>
          <div class="clearfix">
            <p class="darkblue h5 gibson regular line-height-golden mb2">
              <span>Beskriv projektet så detaljeret som muligt (gerne med navne på produkterne, der er anvendt): </span><span class="red">*</span>
            </p>
            <b-form-textarea class="muted-background p2 gibson h5 line-height-golden border-none not-rounded" :rows="8" v-model="description" :state="validationDescription" type="text" required ></b-form-textarea>
            <b-alert :show="validationDescription === false" variant="danger" class="p1 gibson h5 semi-bold flex justify-start items-center red">Required</b-alert>
          </div>
        </tab-content>
        <tab-content title="3">
          <div class="clearfix gibson">
            <p class="h4 darkblue line-height-golden gibson mb3">
              Ekstra Information
            </p>
          </div>
          <div class="clearfix gibson mb2">
            <p class="h5 darkblue line-height-golden gibson">
              Producenter
            </p>
            <v-select multiple label="Name" v-model="manufacturetype" :options="manufactureoptions" required class="flex col-12 flex-wrap">
              <template slot="no-options">
                Ingen matchende ...
              </template>
            </v-select>
            <b-alert :show="validationType === false" variant="danger">Required</b-alert>
          </div>
          <div class="clearfix gibson mb2">
            <b-col lg="12" md="12" sm="12" v-for="man in manufacturetype" :key="man.name">
              <b-col sm="12" md="12" lg="3">
                <b-form-group :label="man.Name">
                  <b-form-input type="text" v-model="man.name" placeholder="Titel" name="customers[][name]" required class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none"></b-form-input>
                </b-form-group>
              </b-col>
            </b-col>
          </div>
          <div class="clearfix gibson mb2">
            <p class="h5 darkblue line-height-golden gibson mb1">
              Postnummer
            </p>
            <input v-model="postnummer" type="text" class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">f. eks., 2300</p>
          </div>
          <div class="clearfix">
            <p class="h5 darkblue line-height-golden gibson mb1">
              Pris
            </p>
            <input v-model="price" type="text" class="col-12 p2 muted-background gibson h5 not-rounded border-none darkblue">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">DKK inkl. vat</p>
          </div>
          <div class="clearfix">
            <p class="h4 darkblue semi-bold line-height-golden gibson mb1">
              Tid
            </p>
            <input v-model="time"  type="text" class="col-12 p2 muted-background gibson h5 darkblue not-rounded border-none">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">f. eks., 4-6 uger</p>
          </div>
        </tab-content>
        <tab-content title="4" v-if="project_id === undefined">
          <div class="clearfix">
            <div class="celarfix">
              <p class="h5 darkblue semi-bold gibson line-height-3">
                Billede List
              </p>
              <p class="h5 darkblue semi-bold gibson">
                {{images.length}} billeder
              </p>
            </div>
            <div class="flex flex-wrap" v-for="image in images" :key="image">
              <div>
                <b-img :src="image" fluid-grow></b-img>
              </div>
              <!-- <b-card :img-src="image" img-alt="Profil" img-top bg-variant="light" class="border-0">
                <b-card-body class="p-0 border-0">
                  <div class="d-flex justify-content-center">
                    <div>

                    </div>
                  </div>
                </b-card-body>
              </b-card> -->
            </div>
          </div>
          <b-card title="Billede List" :sub-title="images.length + ' Billede'" class="text-center">
            <b-row>
              <div class="py-1"></div>

            </b-row>
          </b-card>
          <div class="clearfix pb3">
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Opgavetype:</p>
              <p class="h5 gibson darkblue mb3">
                <template v-for="task in tasktype">{{ task.TaskTypeName }}, </template>
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Titel:</p>
              <p class="h5 gibson darkblue mb3">
                {{title}}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Beskrivelse:</p>
              <p class="h5 gibson darkblue mb3">
                {{description}}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Producenter:</p>
              <p class="h5 gibson darkblue mb3">
                {{ postnummer }}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Postnummer:</p>
              <p class="h5 gibson darkblue mb3">
                <template v-for="man in manufacturetype" > {{ man.Name }}, </template>
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Pris:</p>
              <p class="h5 gibson darkblue mb3">
                {{ price }}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Tid:</p>
              <p class="h5 gibson darkblue mb3">
                {{ time }}
              </p>
            </div>
          </div>
          <div class="py-2"></div>
        </tab-content>
        <template slot="footer" slot-scope="props" class="flex">
          <div class="wizard-footer-left col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" class="wizard-footer-left">
              <span><i class="el-icon-back"></i></span>
              <span class="h4 gibson line-height-1 ml2 semi-bold mb0">Tilbage</span>
            </wizard-button>
            <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
          </div>
          <div class="wizard-footer-right col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right">
              <span class="h4 gibson line-height-1 mr2 semi-bold mb0">Næste</span>
              <span><i class="el-icon-right"></i></span>
            </wizard-button>

            <wizard-button type="button" v-else @click.native="onComplete" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Færdig' : 'Næste'}}</wizard-button>
          </div>
        </template>
        <div class="py4"></div>
      </form-wizard>
    </div>
    <div class="mt3" v-if="!showMobile">
      <form-wizard ref="wizard" title="" v-if="!success" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949">
        <tab-content title="1 ud af 4" :before-change="validateFirstStep" v-if="project_id === undefined">
          <div class="gibson">
            <p class="h4 darkblue line-height-golden">Billeder</p>
            <p :show="noImage" class="h5 darkblue regular gibson mb2 line-height-3">
              Start med at uploade billeder
            </p>
            <p class="h6 darkblue gibson" :v-html="images.length + ' Billede'"></p>
            <div class="clearfix flex flex-wrap mb2">
              <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
              <div v-for="image in images" :key="image">
                <div class="px2 flex flex-column justify-center items-center mb2">
                  <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                  <button @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="1 ud af 4" v-if="project_id !== undefined">
          <div class="gibson">
            <p class="h4 darkblue line-height-golden">Billeder</p>
            <p class="h6 darkblue gibson" :v-html="images.length + ' Billede'"></p>
            <projectimages :project="project" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image_other" @rorate_image="rorate_image"></projectimages>
          </div>
        </tab-content>
        <tab-content title="2 ud af 4" :before-change="validateSecondStep">
          <div class="clearfix gibson">
            <p class="h4 darkblue line-height-golden gibson mb3">Projektinformationer</p>
          </div>
          <div class="clearfix">
            <p class="darkblue gibson line-height-1 mb1">
              <span>Opgavetype:</span><span class="red">*</span>
            </p>
            <v-select multiple placeholder="Begynd at skrive for at søge" label="TaskTypeName" v-model="tasktype" :state="validationType" :options="taskoptions" required class="gibson h5 flex flex-wrap col-12 self-stretch px0">
              <template slot="no-options">
                <p class="h5 darkblue gibson">Ingen matchende ...</p>
              </template>
            </v-select>
            <b-alert :show="validationType === false" variant="danger">Required</b-alert>
          </div>
          <div class="clearfix my3">
            <p class="darkblue gibson line-height-1 mb1">
              <span>Titel</span><span class="red">*</span>
            </p>
            <input class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none" v-model="title" :state="validationTitle" type="text" required>
            <b-alert :show="validationType === false" class="p1 gibson h5 semi-bold flex justify-start items-center red">
              <span>Required</span>
            </b-alert>
          </div>
          <div class="clearfix">
            <p class="darkblue h5 gibson regular line-height-golden mb2">
              <span>Beskriv projektet så detaljeret som muligt (gerne med navne på produkterne, der er anvendt): </span><span class="red">*</span>
            </p>
            <b-form-textarea class="muted-background p2 gibson h5 line-height-golden border-none not-rounded" :rows="8" v-model="description" :state="validationDescription" type="text" required ></b-form-textarea>
            <b-alert :show="validationDescription === false" variant="danger" class="p1 gibson h5 semi-bold flex justify-start items-center red">Required</b-alert>
          </div>
        </tab-content>
        <tab-content title="3 ud af 4">
          <div class="clearfix gibson">
            <p class="h4 darkblue line-height-golden gibson mb3">
              Ekstra Information
            </p>
          </div>
          <div class="clearfix gibson mb2">
            <p class="h5 darkblue line-height-golden gibson">
              Producenter
            </p>
            <v-select multiple label="Name" v-model="manufacturetype" :options="manufactureoptions" required class="flex col-12 flex-wrap">
              <template slot="no-options">
                Ingen matchende ...
              </template>
            </v-select>
            <b-alert :show="validationType === false" variant="danger">Required</b-alert>
          </div>
          <div class="clearfix gibson mb2">
            <b-col lg="12" md="12" sm="12" v-for="man in manufacturetype" :key="man.name">
              <b-col sm="12" md="12" lg="3">
                <b-form-group :label="man.Name">
                  <b-form-input type="text" v-model="man.name" placeholder="Titel" name="customers[][name]" required class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none"></b-form-input>
                </b-form-group>
              </b-col>
            </b-col>
          </div>
          <div class="clearfix gibson mb2">
            <p class="h5 darkblue line-height-golden gibson mb1">
              Postnummer
            </p>
            <input v-model="postnummer" type="text" class="col-12 p2 muted-background darkblue h5 gibson not-rounded border-none">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">f. eks., 2300</p>
          </div>
          <div class="clearfix">
            <p class="h5 darkblue line-height-golden gibson mb1">
              Pris
            </p>
            <input v-model="price" type="text" class="col-12 p2 muted-background gibson h5 not-rounded border-none darkblue">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">DKK inkl. vat</p>
          </div>
          <div class="clearfix">
            <p class="h4 darkblue semi-bold line-height-golden gibson mb1">
              Tid
            </p>
            <input v-model="time"  type="text" class="col-12 p2 muted-background gibson h5 darkblue not-rounded border-none">
            <p id="input-live-help" class="h6 mediumgreuy line-height-4 my1 gibson regular">f. eks., 4-6 uger</p>
          </div>
        </tab-content>
        <tab-content title="4 ud af 4" v-if="project_id === undefined">
          <div class="clearfix">
            <div class="celarfix">
              <p class="h5 darkblue semi-bold gibson line-height-3">
                Billede List
              </p>
              <p class="h5 darkblue semi-bold gibson">
                {{images.length}} billeder
              </p>
            </div>
            <div class="flex flex-wrap" v-for="image in images" :key="image">
              <div>
                <b-img :src="image" fluid-grow></b-img>
              </div>
              <!-- <b-card :img-src="image" img-alt="Profil" img-top bg-variant="light" class="border-0">
                <b-card-body class="p-0 border-0">
                  <div class="d-flex justify-content-center">
                    <div>

                    </div>
                  </div>
                </b-card-body>
              </b-card> -->
            </div>
          </div>
          <b-card title="Billede List" :sub-title="images.length + ' Billede'" class="text-center">
            <b-row>
              <div class="py-1"></div>

            </b-row>
          </b-card>
          <div class="clearfix pb3">
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Opgavetype:</p>
              <p class="h5 gibson darkblue mb3">
                <template v-for="task in tasktype">{{ task.TaskTypeName }}, </template>
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Titel:</p>
              <p class="h5 gibson darkblue mb3">
                {{title}}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Beskrivelse:</p>
              <p class="h5 gibson darkblue mb3">
                {{description}}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Producenter:</p>
              <p class="h5 gibson darkblue mb3">
                {{ postnummer }}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Postnummer:</p>
              <p class="h5 gibson darkblue mb3">
                <template v-for="man in manufacturetype" > {{ man.Name }}, </template>
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Pris:</p>
              <p class="h5 gibson darkblue mb3">
                {{ price }}
              </p>
            </div>
            <div class="col-12">
              <p class="h6 darkblue gibson mb1">Tid:</p>
              <p class="h5 gibson darkblue mb3">
                {{ time }}
              </p>
            </div>
          </div>
          <div class="py-2"></div>
        </tab-content>
        <template slot="footer" slot-scope="props" class="flex">
          <div class="wizard-footer-left col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" class="wizard-footer-left">
              <span><i class="el-icon-back"></i></span>
              <span class="h4 gibson line-height-1 ml2 semi-bold mb0">Tilbage</span>
            </wizard-button>
            <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
          </div>
          <div class="wizard-footer-right col-6 px0">
            <wizard-button :style="props.fillButtonStyle" v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right">
              <span class="h4 gibson line-height-1 mr2 semi-bold mb0">Næste</span>
              <span><i class="el-icon-right"></i></span>
            </wizard-button>

            <wizard-button type="button" v-else @click.native="onComplete" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Færdig' : 'Næste'}}</wizard-button>
          </div>
        </template>
        <div class="py4"></div>
      </form-wizard>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Haandvaerker from './haandvaerker'
import VueFormWizard from 'vue-form-wizard'
import Dropzone from 'vue2-dropzone'
import vSelect from 'vue-select'
import VueClipboard from 'vue-clipboard2'
import projectimages from './uploads/projectimages'
export default {
  name: 'createnew',
  props: ['projects', 'projects_create'],
  components: {
    Haandvaerker,
    VueClipboard,
    projectimages,
    loading,
    Simplert,
    Dropzone,
    vSelect,
    VueFormWizard
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  watch: {
    'tasktype': function (newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true
      }
    },
    'title': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true
      }
    },
    'description': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true
      }
    }
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: false,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      project_id: '',
      projectType: null,
      Producenter: 0,
      title: '',
      tasktype: [],
      manufacturetype: [],
      project: [],
      description: '',
      price: '',
      url: 'fgd',
      time: '',
      postnummer: '',
      fmans: {
        name: '',
        email: '',
        mobile: ''
      },
      mans: [],
      ProducenterOptions: [],
      manufactureoptions: [],
      images: [],
      taskoptions: [],
      pimages: [],
      projectOptions: [
        'Badeværelse',
        'Gulv',
        'Koekken',
        'Tag',
        'Terrasse',
        'Udestue',
        'Vinduer',
        'Andet'
      ],
      seen: false,
      noImage: false,
      startEdit: false,
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      salesPerson: '',
      success: false,
      kunde: {
        title: '',
        name: '',
        address: '',
        zip: '',
        tlf: '',
        email: ''
      }
    }
  },
  created () {
    this.Reload()
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  },
  methods: {
    onFinished: function () {
      alert('Yay. Done!')
    },
    isLastStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    facebokUrl (url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank')
    },
    successCopy () {
      let obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    onErrorCopy () {
      alert('Kan ikke kopiere')
    },
    validateFirstStep () {
      if (this.images.length === 0) {
        this.noImage = true
        return false
      }
      return true
    },
    validateSecondStep () {
      var validation = true
      console.log(this.tasktype.length)
      if (this.tasktype.length === 0) {
        validation = false
        this.validationType = false
      }
      if (this.title === '') {
        validation = false
        this.validationTitle = false
      }
      if (this.description === '') {
        validation = false
        this.validationDescription = false
      }
      return validation
    },
    onSubmitProjectInfo (evt) {
      evt.preventDefault()
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'addProjectnew', salesPerson: this.salesPerson, levid: this.haaId, title: this.title, description: this.description }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
                this.$router.push('/status-haandvaerker-new')
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn,
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onComplete () {
      this.show = true
      var manufacturelist = []
      for (var i = 0; i < this.manufacturetype.length; i++) {
        var c = this.manufacturetype[i]
        manufacturelist.push(c.ManufactureId)
      }
      var tasktypelist = []
      for (var j = 0; j < this.tasktype.length; j++) {
        var z = this.tasktype[j]
        tasktypelist.push(z.TaskTypeId)
      }
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'addProjectothernew', salesPerson: this.salesPerson, levid: this.haaId, title: this.title, description: this.description, images: JSON.stringify(this.images), tasktypelist: JSON.stringify(tasktypelist), manufacturelist: JSON.stringify(manufacturelist), postnummer: this.postnummer, price: this.price, time: this.time, projectid: this.project_id }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              this.url = res.url
              this.success = true
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    change_position (imageId, projectid) {
    },
    delete_image (image) {
      const index = this.images.indexOf(image)
      if (index > -1) {
        this.images.splice(index, 1)
      }
    },
    'showSuccess': function (file) {
      this.noImage = false
      this.images.push(file.xhr.response)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadImagesPrevProject')
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      this.project_id = this.$route.query.id
      this.show = true
      var data = {operation: 'myProjectInfo', salesPerson: this.salesPerson, levid: this.haaId, projectid: this.project_id}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            this.$emit('UpdateProject', res.projects, res.projects_create)
            this.ProducenterOptions = res.center
            this.Producenter = res.selected
            this.taskoptions = res.TaskType
            this.manufactureoptions = res.manufacture
            if (this.project_id !== undefined) {
              this.project = res.project
              this.title = res.project.title
              this.description = res.project.description
              for (var i = 0; i < res.manufacture.length; i++) {
                var c = res.manufacture[i]
                if (res.project.manufacturetype.includes(c.ManufactureId)) {
                  this.manufacturetype.push(c)
                }
              }
              for (var j = 0; j < res.TaskType.length; j++) {
                var d = res.TaskType[j]
                if (res.project.tasktype.includes(d.TaskTypeId)) {
                  this.tasktype.push(d)
                }
              }
              this.postnummer = res.project.postnummer
              this.price = res.project.price
              this.time = res.project.time
            }
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    delete_image_other (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    rorate_image (imageId, projectid, image, primary) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    SaveImage (imageId, projectid) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      }
      this.$http.post('', dataPartner, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onSubmitKundeInfo (evt) {
      evt.preventDefault()
      alert(JSON.stringify(this.kunde))
      console.log(this.kunde)
      console.log(JSON.stringify(this.kunde))
    },
    resetForm (evt) {
      evt.preventDefault()
      Object.assign(this.$data, this.$options.data.call(this))
    },
    buyProjects () {
      this.$router.push('/purchase')
    }
  }
}
</script>
<style scoped lang="less" v-if="showMobile">
  .wizard-nav {
    li {
      .stepTitle {
        width:100%;
        padding: 1rem;
        font-weight: 600;
        font-family: 'canada-type-gibson';
        background: rgba(178,190,195, 0.1);
        font-size: 1.5rem;
      }
      .stepTitle.active {
        background: rgb(25, 163, 192);
        color: #fff!important;
      }
      .stepTitle::after {
        height: 0;
      }
    }
  }
  .wizard-progress-with-circle {
    display:none;
  }
  .vue-form-wizard {
    padding-bottom: 2rem;
    margin-bottom: 2rem;
  }
  .vue-form-wizard.md .wizard-icon-circle {
    display:none;
  }
  .wizard-btn {

  }
  .vue-dropzone {
    width:100%;
    padding: 0;
    border: 0;
    background: white;
    &:hover {
      background: white;
    }
  }
  .dz-preview {
    display: none!important;
  }
  .wizard-header {
    display: none;
  }
  .vs__dropdown-toggle {
    border:0;
    background: rgba(230, 234, 235, 0.5);
    width:100%;
  }
  .vue-form-wizard .wizard-tab-content {
    padding-top: 50px!important;
  }
  .wizard-footer-left .wizard-btn {
    border: 1px solid rgba(178,190,195, 0.5)!important;
    color: rgba(178,190,195, 0.5)!important;
    background-color: #00968808!important;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-gibson';
    font-weight: 600!important;
    &:hover {
      background: rgba(178,190,195, 0.5);
      color: white;
    }
  }
  .wizard-footer-right .wizard-btn {
    background: rgba(77, 207, 85, 1.0)!important;
    background-color: rgba(77, 207, 85, 1.0)!important;
    color: #fff;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-gibson';
    font-weight: 600!important;
  }
</style>
<style lang="less" v-if="!showMobile">
  .wizard-nav {
    li {
      .stepTitle {
        width:100%;
        color: lighten(#5a5a5a, 40%);
        background-color: #fff;
        border-bottom: 3px solid lighten(#5a5a5a, 60%);
        padding: 1rem .25rem 0.5rem 1rem;
        text-align: left;
        font-weight:400;
        font-size: 13.5px;
      }
      .stepTitle.active {
        background-color: #fff;
        color: lighten(#5a5a5a, 40%)!important;
        border-bottom: 3px solid rgba(77, 207, 85, 1.0);
      }
      .stepTitle::after {
        height: 0;
      }
      .checked + .stepTitle {
        color: rgba(77, 207, 85, 1.0);
        border-bottom: 3px solid rgba(77, 207, 85, 1.0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CreateProjectNew.vue?74a5d69c